import { useState } from "react";
import { SimpleButton } from "../../components/button.jsx/Btn";
import { FaImage, FaLink, FaVideo } from "react-icons/fa";
import { Modal } from "../../components/modal";

export function DocumentsTable({ documents, viewMode }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  // const [viewMode, setViewMode] = useState("board");

  const OpenModal = () => setIsModalOpen(true);
  const CloseModal = () => setIsModalOpen(false);

  // const boardDocument = [
  //   {
  //     id: 1,
  //     name: "Data Survey Form.docx",
  //     owner: "Catherine Jacobs",
  //     lastModified: "10:24 am",
  //     fileType: "docx",
  //   },
  //   {
  //     id: 2,
  //     name: "Implementation Policies.pptx",
  //     owner: "Catherine Jacobs",
  //     lastModified: "10:24 am",
  //     fileType: "pptx",
  //   },
  //   {
  //     id: 3,
  //     name: "Exit Interview Form.docx",
  //     owner: "Catherine Jacobs",
  //     lastModified: "10:24 am",
  //     fileType: "docx",
  //   },
  //   {
  //     id: 4,
  //     name: "Asset Return Checklist.pptx",
  //     owner: "Catherine Jacobs",
  //     lastModified: "10:24 am",
  //     fileType: "pptx",
  //   },
  // ];

  const handleSubmit = (e) => {
    e.preventDefault();

    CloseModal();
  };
  return (
    <div className="space-y-6">
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <h2 className="text-2xl font-semibold text-gray-900">
              All Documents
            </h2>
            <div className="px-3 py-1 bg-gray-100 rounded-md">
              <span className="text-sm text-gray-600">Offboarding</span>
            </div>
          </div>

          <SimpleButton
            onClick={OpenModal}
            className="bg-[#1234CD] px-6 py-3 rounded-full hover:bg-blue-700 text-white"
          >
            {/* <span className="mr-2">+</span> */}
            Add new
          </SimpleButton>
        </div>

        {viewMode === "list" ? (
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-gray-50 border-b border-gray-200">
                  <tr>
                    <th className="text-left py-3 px-6 text-sm font-medium text-gray-500">
                      Name
                    </th>
                    <th className="text-left py-3 px-6 text-sm font-medium text-gray-500">
                      Owner
                    </th>
                    <th className="text-left py-3 px-6 text-sm font-medium text-gray-500">
                      Created on
                    </th>
                    <th className="text-left py-3 px-6 text-sm font-medium text-gray-500">
                      Last modified on
                    </th>
                    <th className="text-left py-3 px-6 text-sm font-medium text-gray-500">
                      Modified by
                    </th>
                    <th className="text-left py-3 px-6 text-sm font-medium text-gray-500">
                      Actions
                    </th>
                  </tr>
                </thead>

                <tbody className="divide-y divide-gray-200">
                  {documents.map((document) => (
                    <tr
                      key={document.id}
                      className="hover:bg-gray-50"
                    >
                      <td className="py-4 px-6">
                        <div className="flex items-center gap-3">
                          <div className="w-8 h-8 rounded-md flex items-center justify-center">
                            {/* <span className="text-blue-600 text-sm">📄</span> */}
                            <img
                              src={document.image}
                              alt={document.name}
                            />
                          </div>
                          <span className="text-sm font-medium text-gray-900">
                            {document.name}
                          </span>
                        </div>
                      </td>
                      <td className="py-4 px-6 text-sm text-gray-700">
                        {document.owner}
                      </td>
                      <td className="py-4 px-6 text-sm text-gray-700">
                        {document.createdOn}
                      </td>
                      <td className="py-4 px-6 text-sm text-gray-700">
                        {document.lastModified}
                      </td>
                      <td className="py-4 px-6 text-sm text-gray-700">
                        {document.modifiedBy}
                      </td>
                      <td className="py-4 px-6">
                        <button className="text-blue-600 hover:text-blue-800 text-sm font-medium">
                          Manage document
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ) : (
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-gray-50 border-b border-gray-200">
                  <tr>
                    <th className="text-left py-3 px-6 text-sm font-medium text-gray-500">
                      Name
                    </th>
                    <th className="text-left py-3 px-6 text-sm font-medium text-gray-500">
                      Owner
                    </th>
                    <th className="text-left py-3 px-6 text-sm font-medium text-gray-500">
                      Created on
                    </th>
                    <th className="text-left py-3 px-6 text-sm font-medium text-gray-500">
                      Last modified on
                    </th>
                    <th className="text-left py-3 px-6 text-sm font-medium text-gray-500">
                      Modified by
                    </th>
                    <th className="text-left py-3 px-6 text-sm font-medium text-gray-500">
                      Actions
                    </th>
                  </tr>
                </thead>

                <tbody className="divide-y divide-gray-200">
                  {documents.map((document) => (
                    <tr
                      key={document.id}
                      className="hover:bg-gray-50"
                    >
                      <td className="py-4 px-6">
                        <div className="flex items-center gap-3">
                          <div className="w-8 h-8 rounded-md flex items-center justify-center">
                            {/* <span className="text-blue-600 text-sm">📄</span> */}
                            <img
                              src={document.image}
                              alt={document.name}
                            />
                          </div>
                          <span className="text-sm font-medium text-gray-900">
                            {document.name}
                          </span>
                        </div>
                      </td>
                      <td className="py-4 px-6 text-sm text-gray-700">
                        {document.owner}
                      </td>
                      <td className="py-4 px-6 text-sm text-gray-700">
                        {document.createdOn}
                      </td>
                      <td className="py-4 px-6 text-sm text-gray-700">
                        {document.lastModified}
                      </td>
                      <td className="py-4 px-6 text-sm text-gray-700">
                        {document.modifiedBy}
                      </td>
                      <td className="py-4 px-6">
                        <button className="text-blue-600 hover:text-blue-800 text-sm font-medium">
                          Manage document
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Modal */}
        <Modal
          isOpen={isModalOpen}
          onClose={CloseModal}
        >
          <div>
            <form onSubmit={handleSubmit}>
              <p className="text-[#000000] text-xl font-bold">Add file</p>

              <div className="grid grid-cols-2 gap-6">
                <div className="my-2">
                  <label
                    htmlFor="title"
                    className="text-[#000000]"
                  >
                    First Name
                  </label>
                  <input
                    className="w-full text-center border-[#D0D0D0] border-2 outline-none rounded-md p-2"
                    placeholder="Name"
                    id="title"
                    type="text"
                  />
                </div>

                <div className="my-2">
                  <label
                    htmlFor="folder"
                    className="text-[#000000]"
                  >
                    Select Folder
                  </label>
                  <input
                    className="w-full text-center p-2 border-[#D0D0D0] border-2 outline-none rounded-md"
                    placeholder="Choose folder"
                    id="folder"
                    type="text"
                  />
                </div>
              </div>

              <div className="mb-6">
                <label
                  htmlFor="desc"
                  className="text-[#000000]"
                >
                  File description
                </label>
                <textarea
                  id="desc"
                  className="w-full text-center p-4 border-[#D0D0D0] border-2 outline-none rounded-md"
                  placeholder="Enter description"
                />
              </div>

              {/* Radio Group */}
              <p>Share by:</p>
              {["Department", "Level", "Grade", "Position"].map((option) => (
                <div
                  key={option}
                  className="gap-2 py-2 flex"
                >
                  <input
                    type="radio"
                    name="shareBy"
                    id={option}
                    value={option}
                  />
                  <label htmlFor={option}>{option}</label>
                </div>
              ))}

              {/* Upload Section */}
              <p className="text-black font-bold text-sm mt-4">
                Upload Attachment
              </p>

              <div className="flex items-center gap-8 text-sm mt-4">
                <button
                  type="button"
                  className="flex items-center gap-1 text-pink-500 hover:text-pink-600 transition"
                >
                  <FaImage className="w-4 h-4" />
                  Image
                </button>
                <button
                  type="button"
                  className="flex items-center gap-1 text-blue-500 hover:text-blue-600 transition"
                >
                  <FaVideo className="w-4 h-4" />
                  Video
                </button>
                <button
                  type="button"
                  className="flex items-center gap-1 text-orange-500 hover:text-orange-600 transition"
                >
                  <FaLink className="w-4 h-4" />
                  Link
                </button>
              </div>

              <div className="mx-auto justify-center items-center flex">
                <SimpleButton
                  type="submit"
                  className="bg-[#1234CD] mx-auto
                         w-[180px] h-[59px] flex justify-center items-center text-center  mt-6 p-3 hover:bg-blue-700 text-xl text-white"
                >
                  Create
                </SimpleButton>
              </div>
            </form>
          </div>
        </Modal>
      </div>
    </div>
  );
}
